import React from "react";

/** Tool output as the server hands it back: a string, often one long line of
 *  JSON. Pretty-print when it parses; otherwise wrap so it stays readable. */
export function prettyOutput(text) {
  const raw = text || "";
  const t = raw.trim();
  if ((t.startsWith("{") && t.endsWith("}")) || (t.startsWith("[") && t.endsWith("]"))) {
    try { return JSON.stringify(JSON.parse(t), null, 2); } catch { /* not JSON */ }
  }
  return raw;
}

export default function ToolOutput({ text }) {
  return <pre className="tool-pre tool-pre--wrap">{prettyOutput(text)}</pre>;
}
